import { registerTldrawLibraryVersion } from "@tldraw/utils";
import { ClientWebSocketAdapter, ReconnectManager } from "./lib/ClientWebSocketAdapter.mjs";
import { RoomSessionState } from "./lib/RoomSession.mjs";
import { TLRemoteSyncError } from "./lib/TLRemoteSyncError.mjs";
import { TLSocketRoom } from "./lib/TLSocketRoom.mjs";
import {
  TLSyncClient,
  TLSyncErrorCloseEventCode,
  TLSyncErrorCloseEventReason
} from "./lib/TLSyncClient.mjs";
import {
  DocumentState,
  TLSyncRoom
} from "./lib/TLSyncRoom.mjs";
import { chunk } from "./lib/chunk.mjs";
import {
  RecordOpType,
  ValueOpType,
  applyObjectDiff,
  diffRecord,
  getNetworkDiff
} from "./lib/diff.mjs";
import {
  TLIncompatibilityReason,
  getTlsyncProtocolVersion
} from "./lib/protocol.mjs";
registerTldrawLibraryVersion(
  "@tldraw/sync-core",
  "3.12.0",
  "esm"
);
export {
  ClientWebSocketAdapter,
  DocumentState,
  ReconnectManager,
  RecordOpType,
  RoomSessionState,
  TLIncompatibilityReason,
  TLRemoteSyncError,
  TLSocketRoom,
  TLSyncClient,
  TLSyncErrorCloseEventCode,
  TLSyncErrorCloseEventReason,
  TLSyncRoom,
  ValueOpType,
  applyObjectDiff,
  chunk,
  diffRecord,
  getNetworkDiff,
  getTlsyncProtocolVersion
};
//# sourceMappingURL=index.mjs.map
